// Últimas preguntas que el cliente le hizo al asistente de ayuda (GOL-11).
//
// Vive en el módulo y no en el estado de React a propósito: quien escribe a
// soporte casi siempre viene de intentarlo con el asistente, y esas preguntas son
// el mejor resumen de su problema. Subir ese estado por toda la jerarquía solo
// para arrastrarlo hasta el formulario complicaría tres componentes; aquí es un
// dato efímero de la sesión que se lee una vez y no afecta a ningún render.

const MAX = 2;
let asked: string[] = [];

export function recordAssistantQuestion(question: string): void {
  const clean = question.trim();
  if (!clean) return;
  asked = [...asked, clean].slice(-MAX);
}

export function recentAssistantQuestions(): string[] {
  return asked;
}
